// client/src/coms/voip/shareErrors.js
// Readable messages for screen / camera share failures, so users never see raw error codes.

export function describeShareError(reason, kind = 'screen') {
  const raw = String(reason || '').trim();
  const what = kind === 'camera' ? 'camera' : 'screen';
  if (!raw) return '';
  if (raw === 'no_screen_permission') return 'You do not have permission to share your screen in this channel.';
  if (raw === 'no_camera_permission') return 'You do not have permission to use your camera in this channel.';
  if (raw === 'screen_share_unsupported') return 'Screen sharing is not supported in this browser.';
  if (raw === 'no_room') return 'Join a voice channel first.';
  if (/NotAllowedError|Permission denied|permission dismissed|cancel/i.test(raw)) {
    return `${what === 'camera' ? 'Camera access' : 'Screen sharing'} was cancelled or blocked.`;
  }
  if (/NotReadableError|could not start|in use/i.test(raw)) {
    return what === 'camera'
      ? 'Your camera is in use by another app or could not be started.'
      : 'The screen could not be captured. Another app may be blocking capture (on macOS, allow Screen Recording for this app).';
  }
  if (/NotFoundError|no device/i.test(raw)) return what === 'camera' ? 'No camera was found.' : 'Nothing was selected to share.';
  if (raw === 'screen_track_missing') return 'No video was captured from the selected source.';
  if (/livekit_publish_failed|publish/i.test(raw)) return 'Could not start the stream through the voice server. Try again.';
  if (/^[a-z0-9_:]+$/.test(raw)) return `Could not start ${what} sharing (${raw}).`;
  return raw;
}
